/**
 * Created by User on 2017. 01. 31..
 */

function Filter() {

}